<mat-toolbar class="app-main-menu justify-center py2 mat-{{ color }}">
  <div
    class="app-main-menu-content flex justify-between border-box col-12 mx-auto py1"
    [class.flex-wrap]="!nowrap"
    [ngClass]="{ 'app-main-menu-content--restricted': !fullWidth }"
  >
    <div class="fit flex items-center">
      <ng-content select="[left]"></ng-content>
    </div>

    <div class="fit flex items-center">
      <ng-content select="[right]"></ng-content>
    </div>
  </div>
</mat-toolbar>
